/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-multi-comp */
import 'react-datepicker/dist/react-datepicker.css';
import React, { useReducer, useState, useEffect } from 'react';
import _, { isFunction } from 'lodash';
import { Alert, Form, Button, DatePicker, FormControl, SelectPicker } from 'rsuite';
import { capitalizeFirstLetter } from '../helpers';
import { ColumnStatus, WidgetAccount, WidgetDate, WidgetTitleSubtitle } from '../components';
import { dateFns } from '../components/DateFnsUtils';
import { Table } from '../components/table/Table';
import CuotitasStore from '../services/cuotitasStore';
import FilterQueryParams from '../components/FilterQueryParams';
import loanStatuses from '../constants/loans/statuses';
import REQUEST_TYPES from '../constants/signs/requestTypes';
import STATUS_SIGN from '../constants/signs/statuses';
import Tabs from '../components/Tabs.js';
import validator from '../helpers/validator';

function ColumnClient (cellContent) {
    return (
        <WidgetTitleSubtitle
            title={(<WidgetAccount account={[cellContent.name, cellContent.lastname]} />)}
        />
    );
}

function ColumnDate (cellContent) {
    return (<WidgetDate date={new Date(cellContent)} />);
}

function ColumnState (cellContent, row) {
    const statusType = row.signStatus === STATUS_SIGN.SUCCESS ? 'success' : cellContent.type;
    return <div className='d-flex align-items-center'>
        <ColumnStatus type={statusType} text={cellContent.text} />
        {row.signStatus === STATUS_SIGN.SUCCESS &&
            <i className="fa fa-check-circle text-success ml-1"/>
        }
    </div>;
}
const TYPE_DROWDOWN_OPTIONS = {
    commerce: 'COMERCIO',
    bussinessUnit: 'UNIDAD DE NEGOCIO',
    firstname: 'NOMBRE',
    dni: 'DNI'
};

const filterModes = [
    { label: 'COMERCIO', value: 'COMERCIO' },
    { label: 'UNIDAD DE NEGOCIO', value: 'UNIDAD DE NEGOCIO' },
    { label: 'NOMBRE', value: 'NOMBRE' },
    { label: 'DNI', value: 'DNI' },
];

const initialFilter = {
    filters: null,
    sortOrder: 'desc',
    sortField: 'created_at',
    pageNumber: 1,
    pageSize: 10
};

export default function LoansList () {
    const tabs = [
        { id: 1, name: 'pending', label: 'Pendientes' },
        { id: 3, name: 'success', label: 'Exitosos' },
        { id: 4, name: 'cancelled', label: 'Anulados' },
        { id: 5, name: 'rejected', label: 'Rechazados' },
        { id: 6, name: 'liquidated', label: 'Liquidados' },
        { id: 7, name: 'observed', label: 'Observados' },
    ];

    const columns = [
        { dataField: 'id', text: 'ID', sort: false },
        { dataField: 'client', text: 'Cliente', sort: false, align: 'left', formatter: ColumnClient },
        { dataField: 'clientDNI', text: 'DNI', sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'commerce', text: 'Comercio', sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'amount', text: 'Monto', sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'creditNumber', text: 'Nro. de Crédito', sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'businessUnit', text: 'Unidad de negocios', sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'createdAt', text: 'Fecha', sort: false, formatter: ColumnDate },
        { dataField: 'status', text: 'Estado', sort: false, align: 'left', headerAlign: 'left', formatter: ColumnState },
    ];

    const [isLoading, setIsLoading] = useState(false);

    const [query, setQuery] = useReducer((oldQuery, newQuery) => {
        if (isFunction(newQuery)) {
            return newQuery(oldQuery);
        }
        return newQuery;
    }, {
        sortOrder: 'desc',
        sortField: 'ID',
        pageNumber: 1,
        pageSize: 10
    });

    const [tab, setTab] = useState(tabs[0]);
    const [rechargesList, setRechargesList] = useState([]);

    const [dropdownSelected, setDropdownSelected] = useState(TYPE_DROWDOWN_OPTIONS.dni);
    const [searchText, setSearchText] = useState('');
    const [searchLastname, setsearchLastname] = useState('');
    const [date, setDate] = useState(null);

    function onSelectDropdownItem (ev) {
        setDropdownSelected(ev);
    };

    function onChangeSearchText (ev) {
        setSearchText(ev);
    };

    function onChangeSearchLastname (ev) {
        setsearchLastname(ev);
    };

    function clearFilters () {
        setDate(null);
        setSearchText('');
        setsearchLastname('');
        setQuery(initialFilter);
    };

    async function filter () {
        try {
            setIsLoading(true);

            const filters = new FilterQueryParams();

            const { sortField, sortOrder } = query;
            const options = {
                order: `${sortField}-${sortOrder.toUpperCase()}`,
                pageSize: query.pageSize,
                page: query.pageNumber,
            };

            filters.equal('loan_request.id_loan', REQUEST_TYPES.commerce);
            filters.equal('loan_request.id_loan_request_status', tab.id);

            if (date) {
                const startAt = dateFns.parse(dateFns.format(date, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');

                let startTo = dateFns.addDays(date, -1);
                startTo = dateFns.parse(dateFns.format(date - 1, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');

                filters.between('created_at', dateFns.format(startTo, 'y-MM-dd 00:00:00'), dateFns.format(startAt, 'y-MM-dd 23:59:59'));
            }

            if (searchText || searchLastname) {
                const name = `*${searchText.trim()}*`;
                const lastName = `*${searchLastname.trim()}*`;
                const term = `*${searchText.trim()}*`;
                const numberTerm = `${searchText}`.padEnd(8, '0');

                if (validator.isInteger(searchText) && dropdownSelected === TYPE_DROWDOWN_OPTIONS.dni) {
                    const lessThanTerm = (Number(searchText) + 1).toString().padEnd(8, '0');
                    filters.greaterThanOrEqual('loan_request.loan_request_external_person.content.document', Number(numberTerm));
                    filters.lessThan('loan_request.loan_request_external_person.content.document', lessThanTerm);
                }

                if (dropdownSelected === TYPE_DROWDOWN_OPTIONS.commerce) {
                    filters.like('store.name', capitalizeFirstLetter(term));
                }

                if (dropdownSelected === TYPE_DROWDOWN_OPTIONS.bussinessUnit) {
                    filters.like('store.business_unit', capitalizeFirstLetter(term));
                }

                if (dropdownSelected === TYPE_DROWDOWN_OPTIONS.firstname) {
                    filters.like('loan_request.loan_request_external_person.content.firstName', name.toUpperCase());
                    filters.like('loan_request.loan_request_external_person.content.lastName', lastName.toUpperCase());
                }
            }

            options.filters = filters.build();

            const requests = await CuotitasStore.getLoans(options);

            const loans = requests.map((request, i) => {
                return {
                    id: request.loan_request.id,
                    client: { name: request.loan_request.external_person.content.firstName, lastname: request.loan_request.external_person.content.lastName },
                    clientDNI: request.loan_request.external_person.content.document,
                    commerce: request.store.name,
                    amount: request.loan_request.amount,
                    creditNumber: request.loan_request.metadata.response.NumeroCredito,
                    businessUnit: request.store.business_unit,
                    createdAt: request.created_at,
                    status: loanStatuses[request.loan_request.id_loan_request_status],
                    signStatus: request.sign_request.id_cuotitas_request_status
                };
            });

            setRechargesList(loans);
        }
        catch (error) {
            console.error(error);
            Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        filter();
    }, [query, tab, date]);

    useEffect(() => {
        if (searchText === '') {
            filter();
        }
    }, [searchText]);

    useEffect(() => {
        setQuery({ ...query, pageNumber: 1 });
    }, [tab]);

    return (
        <main className='page'>
            <h1 className='page-header'>Préstamos Cuota Ya</h1>
            <div className="page-filters">
                <Tabs
                    className="page-filters-tabs"
                    items={tabs}
                    selected={tab}
                    onSelect={setTab}
                />
                <div className="page-filters-toolbar">
                    <Form id="form-toolbar" className="page-filters-form" onSubmit={filter}>
                        <FormControl
                            placeholder={`Buscar por ${dropdownSelected === 'DNI' ? dropdownSelected : _.capitalize(dropdownSelected.toLowerCase())}`}
                            appearance='subtle'
                            style={{ width: 300 }}
                            value={searchText}
                            onChange={onChangeSearchText}
                        />
                        {dropdownSelected === TYPE_DROWDOWN_OPTIONS.firstname && <FormControl
                            placeholder='Apellido'
                            appearance='subtle'
                            style={{ width: 200 }}
                            value={searchLastname}
                            onChange={onChangeSearchLastname}
                        />}
                        <DatePicker
                            oneTap
                            style={{ width: 150 }}
                            size='md'
                            placeholder='Fecha de Alta'
                            limitEndYear={2020}
                            renderValue={(value, format) => `${dateFns.format(value, 'dd/MM/y')}`}
                            value={date}
                            onChange={setDate}
                            onClean={() => setDate(null)}
                        />
                        <SelectPicker
                            className='border rounded-sm w-full'
                            title='Tipo de búsqueda'
                            trigger={'click'}
                            appearance='subtle'
                            value={dropdownSelected}
                            onSelect={onSelectDropdownItem}
                            data={filterModes}
                        />
                    </Form>
                    <div className="page-filters-actions">
                        <Button type="submit" form="form-toolbar" appearance='primary' loading={isLoading} >
                            Buscar
                        </Button>
                        <Button className='toolbar-btn' appearance='primary' onClick={clearFilters} disabled={isLoading}>
                            limpiar Filtros
                        </Button>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <Table
                    data={rechargesList}
                    columns={columns}
                    onChange={setQuery}
                    isLoading={isLoading}
                    pagination={{
                        sizePerPage: query.pageSize,
                        page: query.pageNumber,
                    }}
                />
            </div>
        </main>
    );
}
